module.exports = __webpack_public_path__ + "static/image5-f206819665e74a546501e08a863aae9c.jpg";